export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2f-51d49ad2996ed584f65dc52f441fef3d.webp";